<mat-tel-input
  [id]="id"
  [name]="name"
  [required]="required"
  [disabled]="disabled"
  [preferredCountries]="preferredCountries"
  format="national"
  describedBy="phoneInput"
  (change)="onTextInputChange($event, phone)"
  #phone
></mat-tel-input>
